import LegalLayout from '../components/LegalLayout';

const Article = ({ num, title, children }: { num: string; title: string; children: React.ReactNode }) => (
  <article className="mb-10">
    <h2 className="text-lg font-bold text-[#C9A227] mb-4 flex items-center gap-3">
      <span className="text-xs font-mono text-white/20 w-8">ART.</span>
      <span>{num} — {title}</span>
    </h2>
    <div className="pl-11 space-y-3 text-white/70 text-sm leading-relaxed">
      {children}
    </div>
  </article>
);

export default function CguPage() {
  return (
    <LegalLayout
      title="Conditions Générales d'Utilisation"
      subtitle="En vigueur au 27 janvier 2026 — Conformes au droit français et au RGPD"
    >
      <div className="bg-[#0D1228] border border-white/[0.07] rounded-lg p-6 mb-10 text-xs text-white/40 flex items-start gap-3">
        <i className="ri-file-text-line text-[#C9A227] text-base mt-0.5 shrink-0"></i>
        <p>
          Les présentes Conditions Générales d&apos;Utilisation (CGU) régissent l&apos;accès et l&apos;utilisation du site et de la plateforme <strong className="text-white/60">lereseausportif.com</strong>, édités par <strong className="text-white/60">MADAME AURELIE PINTO</strong>, micro-entrepreneur, sous le nom commercial <strong className="text-white/60">AD.NOVA.PRO</strong>. L&apos;utilisation du site implique l&apos;acceptation pleine et entière des présentes CGU.
        </p>
      </div>

      <Article num="1" title="Identification de l'éditeur">
        <div className="bg-[#080C1E] rounded-lg border border-white/[0.05] p-5 space-y-2 text-xs">
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Nom</span><span>MADAME AURELIE PINTO</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Statut</span><span>Micro-entrepreneur</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">SIRET</span><span>100 385 756 00018</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Code NAF</span><span>7022Z</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Adresse</span><span>2 allée des jardins de Courrejean, 33140 Villenave-d&apos;Ornon</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Téléphone</span><span>06 14 12 68 69</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Email</span><span>ad.nova.pro33@gmail.com</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Site</span><span>lereseausportif.com</span></div>
        </div>
      </Article>

      <Article num="2" title="Objet de la plateforme">
        <p>
          La plateforme lereseausportif.com, opérée par AD.NOVA.PRO, est un réseau privé Sport &amp; Business destiné à accompagner les sportifs professionnels et semi-professionnels dans leur reconversion vers l&apos;entrepreneuriat.
        </p>
        <p>Elle offre notamment :</p>
        <ul className="list-disc list-inside space-y-1 text-white/60 pl-2">
          <li>Un accès à une communauté privée de sportifs et entrepreneurs</li>
          <li>La mise en relation avec des experts qualifiés (juridique, financier, immobilier…)</li>
          <li>Des ressources exclusives sur la reconversion et l&apos;entrepreneuriat</li>
          <li>L&apos;organisation et la participation à des événements de networking privés</li>
          <li>Un accompagnement structuré à la construction de projet</li>
        </ul>
      </Article>

      <Article num="3" title="Accès à la plateforme — Création de compte">
        <p>
          L&apos;accès à la plateforme lereseausportif.com est réservé aux personnes majeures (18 ans ou plus) ayant créé un compte membre et souscrit à un abonnement valide.
        </p>
        <p>
          Lors de la création de son compte, l&apos;utilisateur s&apos;engage à fournir des informations exactes, complètes et à les maintenir à jour. Tout compte créé avec de fausses informations pourra être suspendu ou supprimé.
        </p>
        <p>
          L&apos;utilisateur est responsable de la confidentialité de ses identifiants de connexion et de toute activité réalisée depuis son compte. Toute utilisation non autorisée doit être immédiatement signalée à AD.NOVA.PRO.
        </p>
      </Article>

      <Article num="4" title="Règles d'utilisation de la plateforme">
        <p>
          L&apos;utilisateur s&apos;engage à utiliser la plateforme dans le strict respect des lois et règlements en vigueur, et conformément aux présentes CGU.
        </p>
        <p className="font-semibold text-white/80">Sont notamment interdits :</p>
        <ul className="list-disc list-inside space-y-1 text-white/60 pl-2">
          <li>La publication de contenus illicites, diffamatoires, discriminatoires ou portant atteinte à la dignité des personnes</li>
          <li>Le démarchage commercial ou publicitaire non autorisé auprès des autres membres</li>
          <li>La revente ou le partage des accès et contenus de la plateforme</li>
          <li>Toute tentative d&apos;intrusion, de piratage ou d&apos;atteinte à l&apos;intégrité technique de la plateforme</li>
          <li>L&apos;usurpation d&apos;identité ou la création de faux profils</li>
          <li>La collecte non autorisée de données personnelles d&apos;autres membres</li>
        </ul>
        <p>
          Tout manquement à ces règles pourra entraîner la suspension ou la suppression définitive du compte, sans préavis ni remboursement.
        </p>
      </Article>

      <Article num="5" title="Contenus publiés par les utilisateurs">
        <p>
          L&apos;utilisateur est seul responsable des contenus qu&apos;il publie sur la plateforme (posts, commentaires, messages, profil…). Il garantit détenir les droits nécessaires sur tout contenu publié et ne pas porter atteinte aux droits de tiers.
        </p>
        <p>
          En publiant un contenu, l&apos;utilisateur accorde à AD.NOVA.PRO une licence non exclusive, gratuite, mondiale et pour toute la durée légale des droits, d&apos;utiliser, reproduire et diffuser ce contenu dans le cadre du fonctionnement de la plateforme.
        </p>
        <p>
          AD.NOVA.PRO se réserve le droit de modérer, supprimer ou rendre inaccessible tout contenu contraire aux présentes CGU, sans obligation de notification préalable.
        </p>
      </Article>

      <Article num="6" title="Droit de rétractation">
        <p>
          Conformément aux articles L.221-18 et suivants du Code de la consommation, l&apos;utilisateur consommateur dispose d&apos;un délai de rétractation de <strong className="text-white/80">14 jours calendaires</strong> à compter de la conclusion du contrat d&apos;abonnement pour exercer son droit de rétractation, sans avoir à justifier de motifs ni à payer de pénalités.
        </p>
        <p>
          Pour exercer ce droit, l&apos;utilisateur adresse une notification claire à <a href="mailto:ad.nova.pro33@gmail.com" className="text-[#C9A227] hover:underline">ad.nova.pro33@gmail.com</a> avant l&apos;expiration du délai de 14 jours.
        </p>
        <p className="font-semibold text-white/80">Exception :</p>
        <p>
          Conformément à l&apos;article L.221-28, 1° du Code de la consommation, si l&apos;utilisateur a expressément demandé que l&apos;exécution du service commence avant la fin du délai de rétractation et que le service a été pleinement exécuté, le droit de rétractation est perdu. L&apos;utilisateur en est informé et donne son consentement exprès lors de l&apos;activation immédiate de son accès.
        </p>
        <p>
          En cas de rétractation valide, le remboursement est effectué dans les 14 jours par le même moyen de paiement.
        </p>
      </Article>

      <Article num="7" title="Propriété intellectuelle">
        <p>
          L&apos;ensemble des éléments constituant la plateforme lereseausportif.com (logo, charte graphique, textes, ressources, méthodologies, contenus exclusifs…) sont la propriété exclusive d&apos;AD.NOVA.PRO et sont protégés par le droit de la propriété intellectuelle français et international.
        </p>
        <p>
          L&apos;accès à la plateforme ne confère à l&apos;utilisateur aucun droit de reproduction, d&apos;exploitation commerciale ou de redistribution des contenus. Tout usage non autorisé est passible de poursuites au titre de la contrefaçon.
        </p>
      </Article>

      <Article num="8" title="Protection des données personnelles">
        <p>
          AD.NOVA.PRO traite les données personnelles des utilisateurs conformément au Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679) et à la loi Informatique et Libertés n° 78-17 du 6 janvier 1978 modifiée.
        </p>
        <p>
          <strong className="text-white/80">Responsable du traitement :</strong> Madame Aurélie Pinto — ad.nova.pro33@gmail.com
        </p>
        <p>
          <strong className="text-white/80">Données collectées :</strong> prénom, nom, email, numéro de téléphone, profil sportif et professionnel, données de navigation, données de paiement (gérées par le prestataire de paiement).
        </p>
        <p>
          <strong className="text-white/80">Finalités :</strong> gestion de la relation membre, accès aux services, organisation des événements, amélioration de la plateforme.
        </p>
        <p>
          L&apos;utilisateur dispose d&apos;un droit d&apos;accès, de rectification, d&apos;effacement, de portabilité et d&apos;opposition. Demandes à adresser à <a href="mailto:ad.nova.pro33@gmail.com" className="text-[#C9A227] hover:underline">ad.nova.pro33@gmail.com</a>. En cas de litige non résolu, recours possible auprès de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="nofollow noopener noreferrer" className="text-[#C9A227] hover:underline">www.cnil.fr</a>).
        </p>
      </Article>

      <Article num="9" title="Cookies">
        <p>
          La plateforme lereseausportif.com utilise des cookies. Pour en savoir plus, consultez notre <a href="/legal/cookies" className="text-[#C9A227] hover:underline">Politique de gestion des cookies</a>.
        </p>
      </Article>

      <Article num="10" title="Disponibilité du service — Responsabilité">
        <p>
          AD.NOVA.PRO s&apos;efforce d&apos;assurer la disponibilité de la plateforme 24h/24, 7j/7, mais ne peut garantir une disponibilité sans interruption. Des opérations de maintenance peuvent entraîner des interruptions temporaires, annoncées dans la mesure du possible.
        </p>
        <p>
          AD.NOVA.PRO décline toute responsabilité pour les dommages directs ou indirects résultant d&apos;une interruption de service, d&apos;une perte de données ou d&apos;un accès non autorisé à un compte résultant d&apos;un manquement de l&apos;utilisateur à ses obligations de sécurité.
        </p>
      </Article>

      <Article num="11" title="Médiation de la consommation">
        <p>
          Conformément aux articles L.616-1 et R.616-1 du Code de la consommation, en cas de litige non résolu à l&apos;amiable, l&apos;utilisateur consommateur peut recourir gratuitement à un médiateur de la consommation.
        </p>
        <div className="bg-[#080C1E] rounded-lg border border-[#C9A227]/20 p-4 mt-2">
          <p className="text-white/40 text-xs">
            <strong className="text-white/60">Médiateur compétent :</strong> [Nom et coordonnées du médiateur à compléter lors de l&apos;adhésion au dispositif de médiation]<br />
            Plateforme européenne de règlement en ligne des litiges : <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="nofollow noopener noreferrer" className="text-[#C9A227] hover:underline">ec.europa.eu/consumers/odr</a>
          </p>
        </div>
      </Article>

      <Article num="12" title="Modification des CGU">
        <p>
          AD.NOVA.PRO se réserve le droit de modifier les présentes CGU à tout moment. L&apos;utilisateur sera informé de toute modification substantielle par email et/ou notification sur la plateforme, avec un préavis de 30 jours minimum. La poursuite de l&apos;utilisation de la plateforme après ce délai vaut acceptation des nouvelles CGU.
        </p>
      </Article>

      <Article num="13" title="Droit applicable — Juridiction compétente">
        <p>
          Les présentes CGU sont régies par le droit français. En cas de litige non résolu à l&apos;amiable, la juridiction compétente sera le <strong className="text-white/80">Tribunal judiciaire de Bordeaux</strong>, sous réserve des dispositions d&apos;ordre public applicables aux consommateurs.
        </p>
      </Article>

      <div className="mt-12 pt-8 border-t border-white/[0.07] text-center">
        <p className="text-xs text-white/25">CGU entrées en vigueur le 27 janvier 2026 — Dernière mise à jour : mars 2026 — lereseausportif.com</p>
      </div>
    </LegalLayout>
  );
}
